import Vue from 'vue';
import { gsap } from 'gsap/all';
import lozad from 'lozad'


Vue.component('header-video-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            introVideoLoaded: false,
            overlayVideoPlaying: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        // Start the lazyloading of the intro video
        // this.initIntroVideo();
        // const el = this.$el.querySelector('video');
        // const observer = lozad(el); // passing a `NodeList` (e.g. `document.querySelectorAll()`) is also valid

        // observer.observe();

        gsap.to('.page-header__scroll-cta-text', {
            scrollTrigger: {
                trigger: '.page-content',
                toggleActions: "play none none reverse",
                once: false
            },
            duration: 1.2,
            autoAlpha: 0,
            y: 85,
        });

        gsap.to('.page-header__scroll-cta-line', {
            scrollTrigger: {
                trigger: '.page-content',
                toggleActions: "play none none reverse",
                once: false
            },
            duration: 1.2,
            scaleY: 0,
        });

        if (this.$root.firstLoad) {
            gsap.delayedCall(6, () => {
                this.setupOverlayVideo();
            });
        } else {
            gsap.delayedCall(0.4, () => {
                this.setupOverlayVideo();
            });
        }
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        /**
         * Handle the post event for the newsletter subscribe form
         */
        initIntroVideo() {
            const lazyVideos = [].slice.call(document.querySelectorAll("video.page-header__video"));
            let lazyVideoObserver = null;

            if ("IntersectionObserver" in window) {
                lazyVideoObserver = new IntersectionObserver((entries, observer) => {
                    entries.forEach((video) => {
                        if (video.isIntersecting) {
                            // eslint-disable-next-line no-restricted-syntax,guard-for-in
                            for (const source in video.target.children) {
                                const videoSource = video.target.children[source];
                                if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                                    videoSource.src = videoSource.dataset.src;
                                }
                            }

                            // video.target.oncanplay = () => {
                            //     video.target.play();
                            //     // Vue.nextTick(this.setupOverlayVideo);

                            // gsap.delayedCall(5, () => {
                            //     video.target.play();
                            // })
                            video.target.addEventListener('waiting', () => {
                                console.log(video.target.readyState)
                                if (video.target.readyState >= 2) {
                                    video.target.play();
                                }
                            });

                            video.target.currentTime = 0;
                            video.target.load();
                            console.log(video.target.readyState)
                            video.target.classList.add("loaded");
                            lazyVideoObserver.unobserve(video.target);
                        }
                    });
                });
            }

            lazyVideos.forEach((lazyVideo) => {
                if (lazyVideoObserver) {
                    lazyVideoObserver.observe(lazyVideo);
                }
            });
        },

        /**
         * Setup the plyr instance for the video overlay
         */
        async setupOverlayVideo() {
            // eslint-disable-next-line import/no-unresolved
            const { default: Plyr } = await import(/* webpackChunkName: "plyr" */ 'plyr');

            this.overlayVideo = new Plyr(this.$refs.overlayvideo, {
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
                fullscreen: { enabled: true, fallback: true, iosNative: true },
                iconUrl: '/media/images/video-svg-sprites.svg',
            });

            if (!this.overlayVideo) {
                return;
            }

            this.overlayVideo.on('play', (event) => {
                this.overlayVideoPlaying = true;
                document.querySelector(".page-header__video--portrait").pause();
                document.querySelector(".page-header__video--landscape").pause();
            });

            this.overlayVideo.on('pause', (event) => {
                // this.overlayVideoPlaying = false;
            });

            this.overlayVideo.on('seeking', (event) => {
                this.overlayVideoPlaying = true;
            });

            this.overlayVideo.on('ended', (event) => {
                this.overlayVideoPlaying = false;
                document.querySelector(".page-header__video--portrait").play();
                document.querySelector(".page-header__video--landscape").play();
            });
        },

        /**
         * Play the overlay video
         */
        async playOverlayVideo() {
            if (!this.overlayVideo) {
                await this.setupOverlayVideo();
            }
            this.overlayVideo.play();
            this.overlayVideoPlaying = true;
        },

        /**
         * Stop playing the overlay video
         */
        stopOverlayVideo() {
            this.overlayVideo.pause();
            this.overlayVideoPlaying = false;
            document.querySelector(".page-header__video--portrait").play();
            document.querySelector(".page-header__video--landscape").play();
        },
    }
});
